import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import {ButtonDirective} from 'primeng/button';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-modal-form-delete',
  standalone: true,
  imports: [
    ButtonDirective,
    TranslatePipe
  ],
  template: `
    <div class="p-4">
      <p>{{ config.data.message }}</p>
      <div class="flex justify-content-end gap-2 mt-4">
        <button pButton [label]="'No' | translate" class="p-button-text" (click)="ref.close(false)"></button>
        <button pButton [label]="'Yes' | translate" severity="danger" (click)="ref.close(true)"></button>
      </div>
    </div>
  `
})
export class ModalFormDelete {
  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) {}
}
